export const solotionTabItems = [
  {
    title: "دسترسی به زیرساخت‌های سازمانی (PAM ابری)",
    img: "cdn/startup.svg",
    imgAlt: "دسترسی به زیرساخت‌های سازمانی (PAM ابری)",
    imgTitle: "دسترسی به زیرساخت‌های سازمانی (PAM ابری)",
    img_deactive: "cdn/startup.svg",
    section_title: "دسترسی به زیرساخت‌های سازمانی (PAM ابری)",
    caption:
      "ماژول PAM ابری، به‌عنوان اولین راهکار بومی کشور، امکان دسترسی کاربران به منابع حساس را به‌صورت متمرکز، ثبت‌شده و قابل‌کنترل فراهم می‌سازد. این ماژول فضای کاری امن آبالون، با سایر سرویس‌های ابری به‌صورت یکپارچه عمل می‌کند و نه‌تنها برای حساب‌های ممتاز مانند مدیران سیستم، مدیران شبکه و کارشناسان زیرساخت، بلکه برای کلیه کاربران سازمانی قابل‌استفاده است. هدف، ایمن‌سازی همه سطوح دسترسی، در هر زمان و از هر مکان است.",
    contentImg: "security/firewall-image.svg",
    contentImgAlt: "دسترسی به زیرساخت‌های سازمانی (PAM ابری)",
    contentImgTitle: "دسترسی به زیرساخت‌های سازمانی (PAM ابری)",
    link: "",
    alt: "دسترسی به زیرساخت‌های سازمانی (PAM ابری)",
    contentItem: [
      {
        name: "مدیریت دقیق و قابل‌کنترل دسترسی‌ها برای تمام کاربران",
      },
      {
        name: "ثبت کامل نشست‌های کاری به‌صورت تصویری",
      },
      {
        name: "امکان مشاهده فعالیت‌های اخیر برای رفتارهای مشکوک",
      },
      {
        name: "هماهنگ با سایر سرویس‌های ابری آبالون به‌صورت یکپارچه",
      },
    ],
  },
  {
    title: "دسترسی امن به سامانه‌های وب سازمانی",
    img: "cdn/store.svg",
    imgAlt: "دسترسی امن به سامانه‌های وب سازمانی",
    imgTitle: "دسترسی امن به سامانه‌های وب سازمانی",
    img_deactive: "cdn/store.svg",
    section_title: "دسترسی امن به سامانه‌های وب سازمانی",
    caption:
      "این ماژول فضای کاری امن آبالون،‌ دسترسی به سامانه‌ها و نرم‌افزارهای سازمانی را بدون نیاز به نصب یا تغییر در ساختار سیستم‌های موجود، از طریق دسکتاپ مبتنی بر مرورگر فراهم می‌کند. در یک محیط ایزوله و امن، کاربران دورکار، کارکنان شعب در نقاط مختلف جغرافیایی و حتی افراد مستقر در دفتر مرکزی می‌توانند به‌صورت کنترل‌شده به اپلیکیشن‌های سازمانی مانند اتوماسیون اداری، مالی، منابع انسانی یا سایر سامانه‌های اختصاصی بدون پیچیدگی و با حداکثر امنیت متصل شوند.",
    contentImg: "security/waf-banner.svg",
    contentImgAlt: "دسترسی امن به سامانه‌های وب سازمانی",
    contentImgTitle: "دسترسی امن به سامانه‌های وب سازمانی",
    link: "",
    alt: "دسترسی امن به سامانه‌های وب سازمانی",
    contentItem: [
      {
        name: "اجرای سامانه‌های سازمانی بدون نیاز به نصب یا پیکربندی",
      },
      {
        name: "ثبت کامل نشست‌های کاری به‌صورت اتصال ایمن از راه دور یا داخل سازمان با سطح نظارت یکسان",
      },
      {
        name: "دسکتاپ مبتنی بر مرورگر، سفارشی‌شده برای هر نقش",
      },
      {
        name: "احراز هویت چندمرحله‌ای برای حفاظت از داده‌های کلیدی",
      },
    ],
  },
  {
    title: "دسترسی امن به فایل سرورهای سازمانی",
    img: "cdn/company.svg",
    imgAlt: "دسترسی امن به فایل سرورهای سازمانی",
    imgTitle: "دسترسی امن به فایل سرورهای سازمانی",
    img_deactive: "cdn/company.svg",
    section_title: "دسترسی امن به فایل سرورهای سازمانی",
    caption:
      "این ماژول فضای کاری امن آبالون، بدون نیاز به تغییر در معماری یا زیرساخت فعلی فایل‌سرورهای سازمان، امکان دسترسی امن به منابع ذخیره‌سازی را برای کاربران فراهم می‌کند. صرف‌نظر از ساختار فایل‌سرور، پلتفرم Secure Workspace با پشتیبانی از استانداردها و معماری‌های متنوع، اتصال ساده و سریع به منابع را بدون نیاز به نصب نرم‌افزار یا تنظیمات پیچیده در سمت کاربر امکان‌پذیر می‌کند.",
    contentImg: "security/ddos-image.svg",
    contentImgAlt: "دسترسی امن به فایل سرورهای سازمانی",
    contentImgTitle: "دسترسی امن به فایل سرورهای سازمانی",
    link: "",
    alt: "دسترسی امن به فایل سرورهای سازمانی",
    contentItem: [
      {
        name: "پشتیبانی از انواع پروتکل‌های ذخیره‌سازی",
      },
      {
        name: "بدون نیاز به پیکربندی در سمت کاربر",
      },
      {
        name: "مناسب برای تیم‌های پروژه و پیمانکاران",
      },
      {
        name: "دسترسی امن از طریق دسکتاپ ابری",
      },
    ],
  },
];

export const features = [
  {
    img: "agility.svg",
    title: "دسترسی غیرمستقیم و محافظت‌شده",
    desc: "کاربر بدون ارتباط مستقیم با منابع، تصویری ایزوله‌شده از محیط سازمان را مشاهده می‌کند؛ ارتباطات واقعی از طریق هسته مرکزی پلتفرم برقرار می‌شود.",
    imgAlt: "دسترسی غیرمستقیم و محافظت‌شده",
    imgTitle: "دسترسی غیرمستقیم و محافظت‌شده",
  },
  {
    img: "hardening.svg",
    title: "اتصال به بسترهای پیام‌رسان سازمانی",
    desc: "امکان ارسال اعلان‌ها، کدهای MFA یا پیام‌های سیستمی از طریق سامانه‌های SMS، ایمیل یا سایر کانال‌های داخلی و خارجی فراهم است.",
    imgAlt: "اتصال به بسترهای پیام‌رسان سازمانی",
    imgTitle: "اتصال به بسترهای پیام‌رسان سازمانی",
  },
  {
    img: "devops.svg",
    title: "ثبت و ضبط کامل نشست‌ها",
    desc: "همه فعالیت‌ها در فضای کاری امن ثبت می‌شوند؛ می‌توان محدوده ضبط را به سرورها یا نرم‌افزارهای خاص محدود کرد.",
    imgAlt: "ثبت و ضبط کامل نشست‌ها",
    imgTitle: "ثبت و ضبط کامل نشست‌ها",
  },
  {
    img: "focus.svg",
    title: "اجرای امن از طریق مرورگر",
    desc: "نشست‌های کاری از طریق مرورگر اجرا می‌شوند؛ مرورگر در فضای کاری امن نقش یک سندباکس امن و ایزوله را ایفا می‌کند و نیازی به نصب نرم‌افزار جداگانه ندارد.",
    imgAlt: "اجرای امن از طریق مرورگر",
    imgTitle: "اجرای امن از طریق مرورگر",
  },
  {
    img: "monitoring.svg",
    title: "ارسال لاگ به سامانه‌های امنیتی",
    desc: "رفتار کاربران در نشست کاری در لاگ‌ها ثبت می‌شود و به سامانه‌های SIEM یا SOC منتقل می‌شود تا تحلیل امنیتی و واکنش بلادرنگ انجام شود.",
    imgAlt: "ارسال لاگ به سامانه‌های امنیتی",
    imgTitle: "ارسال لاگ به سامانه‌های امنیتی",
  },
  {
    img: "technical.svg",
    title: "تجربه یکسان، مستقل از محل اتصال",
    desc: "کاربران، چه از داخل سازمان، چه از خانه یا زیرساخت ابری، همیشه تجربه‌ای یکپارچه، روان و بدون وقفه در فضای کاری امن خواهند داشت.",
    imgAlt: "تجربه یکسان، مستقل از محل اتصال",
    imgTitle: "تجربه یکسان، مستقل از محل اتصال",
  },
];

export const cdnCoverage = [
  {
    title: "91%",
    cap: "سازمان‌ها نگران آسیب‌پذیری امنیتی VPNها هستند",
  },
  {
    title: "56%",
    cap: "سازمان‌ها حملات مبتنی بر VPN را تجربه کرده‌اند",
  },
  {
    title: "54%",
    cap: "از حملات موفق VPN مربوط به کاربران دورکار بوده است",
  },
  {
    title: "70%",
    cap: "کاهش حملات با امن کردن فضای کاری اتفاق افتاده است",
  },
];

export const scrubbingCenter = [
  {
    title: "دسترسی موقت مدیران به منابع حیاتی",
    specialChar: "",
    desc: "دسترسی به سرورها یا سامانه‌های حساس حتی برای مدیران ارشد نیز فقط در زمان نیاز، به‌صورت موقت و پس از احراز هویت چندمرحله‌ای و تایید مدیر امنیت فعال می‌شود.",
  },
  {
    title: "دسکتاپ ابری برای کاربران دورکار",
    specialChar: "",
    desc: "کاربران دورکار از طریق مرورگر به فضای کاری امن متصل می‌شوند، در حالی‌که تمامی فعالیت‌ها به صورت تصویری ضبط می‌شود و فقط برنامه‌های مجاز در دسترس هستند.",
  },
  {
    title: "دسترسی محدود و ایمن برای پیمانکاران",
    specialChar: "",
    desc: "دسترسی پیمانکاران یا تیم‌های پشتیبانی خارج از سازمان، بدون نیاز به VPN و فقط در بازه‌ زمانی، مکانی و سطح مجوز مشخص، از طریق مرورگر انجام می‌شود. ",
  },
  {
    title: "اجرای امن وظایف DevOps از راه دور",
    specialChar: "",
    desc: "کارشناسان و تیم‌های فنی با دسترسی محدود شده و مبتنی‌بر نقش می‌توانند وظایف خود را از راه دور انجام دهند؛ هرگونه اتصال، ثبت، زمان‌بندی و به‌دقت پایش می‌شود.",
  },
];

export const serviceFeatures = [
  {
    title: "تحویل سریع محتوا با کمترین تاخیر",
    desc: "با بهره‌مندی از گستره‌ای از پاپ‌سایت‌های داخلی و بین‌المللی در نقاط جغرافیایی متنوع",
    logo: "Feature-1.svg",
    imgAlt: "تحویل سریع محتوا با کمترین تاخیر",
    imgTitle: "تحویل سریع محتوا با کمترین تاخیر",
  },
  {
    title: "افزایش پایداری و دسترس‌پذیری محتوا",
    desc: "دسترسی دائمی به محتوا حتی در صورت از دسترس خارج شدن موقتی سرور",
    logo: "Feature-5.svg",
    imgAlt: "افزایش پایداری و دسترس‌پذیری محتوا",
    imgTitle: "افزایش پایداری و دسترس‌پذیری محتوا",
  },
  {
    title: "مصون از تهدیدات سایبری پیشرفته",
    desc: "محافظت در مقابل انواع تهدیدات و حملات سایبری از جمله DDoS لایه ۳، ۴ و ۷",
    logo: "Feature-6.svg",
    imgAlt: "مصون از تهدیدات سایبری پیشرفته",
    imgTitle: "مصون از تهدیدات سایبری پیشرفته",
  },
  {
    title: "کاهش مصرف منابع و آزادسازی پهنای باند",
    desc: "با فشرده‌سازی هوشمند و کوچک‌سازی فایل‌ها و کاهش تبادل با سرور",
    logo: "Feature-3.svg",
    imgAlt: "کاهش مصرف منابع و آزادسازی پهنای باند",
    imgTitle: "کاهش مصرف منابع و آزادسازی پهنای باند",
  },
  {
    title: "هدایت هوشمند ترافیک میان سرورها",
    desc: "توزیع ترافیک با لودبالانسر DNS و HTTP بر اساس توان زیرساخت سازمان شما",
    logo: "Feature-2.svg",
    imgAlt: "هدایت هوشمند ترافیک میان سرورها",
    imgTitle: "هدایت هوشمند ترافیک میان سرورها",
  },
  {
    title: "فایروال و WAF یکپارچه با CDN",
    desc: "حفاظت پیشرفته از زیرساخت ابری در برابر تهدیدات، بدون نیاز به سخت‌افزار",
    logo: "Feature-7.svg",
    imgAlt: "فایروال و WAF یکپارچه با CDN",
    imgTitle: "فایروال و WAF یکپارچه با CDN",
  },
  {
    title: "DNS ابری سریع با NS اختصاصی",
    desc: "مدیریت دامنه‌ها با DNS همیشه در دسترس و امکان تعریف NS دلخواه سازمانی",
    logo: "Feature-8.svg",
    imgAlt: "DNS ابری سریع با NS اختصاصی",
    imgTitle: "DNS ابری سریع با NS اختصاصی",
  },
  {
    title: "فعال‌سازی خودکار SSL رایگان",
    desc: "امن‌سازی ارتباط کاربران و افزایش اعتبار وب‌سایت با گواهی SSL/TLS رایگان",
    logo: "Feature-4.svg",
    imgAlt: "فعال‌سازی خودکار SSL رایگان",
    imgTitle: "فعال‌سازی خودکار SSL رایگان",
  },
];

export const PopularServices = [
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند SOC، فایروال ابری، WAF و سامانه (SIEM) از سرویس‌های سازمانی خود در فضای ابری محافظت کنید.",
    logo: "VPS-Service.svg",
    route: "/cloud-security",
    imgAlt: "سرویس امنیت ابری آبالون",
    imgTitle: "سرویس امنیت ابری آبالون",
  },
  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "CloudGuard-Service.svg",
    route: "/dedicated-server",
    imgAlt: "سرویس سرور اختصاصی آبالون",
    imgTitle: "سرویس سرور اختصاصی آبالون",
  },
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "شبکه توزیع محتوای CDN آبالون",
    desc: "با بیش از ۴۰ پاپ‌سایت فعال در ایران و ۵ قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان خود را با کمترین تأخیر، سریع‌تر و ایمن‌تر به کاربران برسانید.",
    logo: "ManagedService-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوای CDN آبالون",
    imgTitle: "شبکه توزیع محتوای CDN آبالون",
  },
];

export const questions = [
  {
    title: "پلتفرم فضای کاری امن آبالون چه کاربردی برای سازمان‌ها دارد؟",
    answer:
      "این پلتفرم دسترسی کاربران به سامانه‌ها و منابع سازمانی را به‌صورت کاملاً ایزوله، کنترل‌شده و امن فراهم می‌آورد، به‌گونه‌ای که کاربران بدون ارتباط مستقیم با زیرساخت، صرفاً از طریق یک فضای کاری امن (بر پایه مرورگر) به محیط کاری خود متصل می‌شوند.",
  },
  {
    title: "تفاوت فضای کاری امن آبالون با VPN برای اتصال به سازمان چیست؟",
    answer:
      "در معماری این پلتفرم، برخلاف VPN، کاربر به‌صورت غیرمستقیم و ایزوله به منابع متصل می‌شود. تمام مسیرها، سیاست‌ها و رمزها در پشت‌صحنه مدیریت می‌شوند و مرورگر تنها نقش نمایشگر را دارد.",
  },
  {
    title: "آیا امکان کنترل و نظارت بر فعالیت کاربران وجود دارد؟",
    answer:
      "بله. تمامی فعالیت‌های کاربران در فضای کاری امن آبالون، پس از احراز هویت، هنگام اتصال به منابع سازمانی ثبت و ضبط می‌شوند. این اطلاعات قابل ارسال به سامانه‌های تحلیل امنیتی مانند SIEM نیز هستند.",
  },
  {
    title:
      "آیا کاربران خارج از سازمان یا پیمانکاران هم می‌توانند از این پلتفرم استفاده کنند؟",
    answer:
      "بله. با توجه به احراز هویت چندمرحله‌ای و معماری Zero Trust، این پلتفرم دسترسی امن برای کاربران برون‌سازمانی، پیمانکاران و حتی کارکنان دورکار را به‌شکل کاملاً کنترل‌شده فراهم می‌کند.",
  },
  {
    title: "مزیت اصلی پلتفرم فضای کاری امن آبالون نسبت به راهکارهای سنتی چیست؟",
    answer:
      "این پلتفرم نیازی به VPN یا نصب نرم‌افزار ندارد، تجربه‌ای روان و یکپارچه در مرورگر فراهم می‌کند، مستقل از محل اتصال یا دستگاه کاربر، کار می‌کند و امکان نظارت دقیق و مستندسازی کامل را برای مدیران امنیتی فراهم می‌سازد.",
  },
];
